//按需引入vant-ui组件
import { Toast,Notify,Dialog,Button,Icon,List,NavBar,Cell,CellGroup,Form,Field,Popup,Picker,Uploader,Tab,Tabs,Sticky,DatetimePicker,Search,PasswordInput,NumberKeyboard,CountDown,DropdownMenu,DropdownItem,Checkbox,CheckboxGroup } from 'vant'; 
import { Image as VanImage } from 'vant';
const compontent = [Toast,Notify,Dialog,Button,List,Icon,NavBar,Cell,CellGroup,Form,Field,Popup,Picker,Uploader,Tab,Tabs,Sticky,DatetimePicker,Search,PasswordInput,NumberKeyboard,CountDown,DropdownMenu,DropdownItem,Checkbox,CheckboxGroup,VanImage]
 
export default function install(Vue) {
	if (install.installed) return
	compontent.forEach(i => Vue.component(i.name, i))
}